import { compact } from 'lodash';
import { useCompetition, useRootStore } from '@nandosaus/state-management';

import { navigation } from '../../constants';
import { useFeature } from '../use-feature';

const useAccountNavigationItems = () => {
  const { FeatureFlagStore, GroupOrderStore } = useRootStore();
  const cateringEnabled = useFeature('catering-enabled');
  const partialPointRedemptionEnabled = useFeature('partial-point-redemption-enabled');
  const { entries, isActive: hasActiveCompetition, userCanEnter: hasCompetitionEntries } = useCompetition();

  const offersItem = !GroupOrderStore.isGroupInvitee
    ? {
        label: partialPointRedemptionEnabled ? 'Perks' : 'Your Offers',
        href: navigation.OFFERS,
      }
    : null;

  return compact([
    partialPointRedemptionEnabled ? offersItem : null,
    {
      label: 'Profile',
      href: navigation.ACCOUNT,
    },
    partialPointRedemptionEnabled ? null : offersItem,
    {
      label: 'Orders',
      href: navigation.ORDERS,
    },
    cateringEnabled
      ? {
          label: 'Catering Orders',
          href: navigation.CATERING_ORDERS,
        }
      : null,
    {
      label: 'Points Activity',
      href: navigation.POINTS_ACTIVITY,
    },
    {
      label: 'Payment Methods',
      href: navigation.PAYMENT_METHODS,
    },
    {
      label: 'Add Receipt',
      href: navigation.ADD_RECEIPT,
    },
    hasActiveCompetition
      ? {
          label: 'Spin-to-Win',
          href: navigation.SPIN_TO_WIN,
          badge: hasCompetitionEntries ? entries : undefined,
        }
      : null,
    FeatureFlagStore.isActive('digital-wallet')
      ? {
          label: 'Digital Wallet',
          href: navigation.DIGITAL_WALLET,
        }
      : null,
    FeatureFlagStore.isActive('communication-preferences')
      ? {
          label: 'Communication Preferences',
          href: navigation.COMMUNICATION_PREFERENCES,
        }
      : null,
    {
      label: 'Help',
      href: navigation.HELP,
    },
  ]);
};

export { useAccountNavigationItems };
